import type { ModuleManifest } from './types';
import { spatialManifest } from './spatial/manifest';
import { financeManifest } from './finance/manifest';
import { adminManifest } from './admin/manifest';

const ALL_MODULES: ModuleManifest[] = [
  spatialManifest,
  financeManifest,
  adminManifest,
];

/**
 * Returns modules that are enabled based on the tenant's feature flags.
 */
export function getEnabledModules(features: Record<string, boolean>): ModuleManifest[] {
  return ALL_MODULES.filter((mod) => features[mod.featureFlag]);
}

export { ALL_MODULES };
export type { ModuleManifest } from './types';
